import moment from "moment"
import { Flex, Text } from "@chakra-ui/react"

import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider"

const ReservationDetailsDate: React.FC = () => {
  const { T, lang } = useUI()
  const { currentReservation: reservation } = useReservationsContext()

  moment.locale(lang)

  return (
   <Flex
    width="283px"
    height="120px"
    flexDirection="column"
    border="1px solid #E9F2FD"
    borderRight="unset"
    borderTop="unset"
    borderLeft="unset"
    padding="14px 0 20px  24px"
   >
    <Text opacity={0.7} mb={"10px"} fontSize={"base"}>
      {T("booking.details.modal.booking.time")}
    </Text>
    <Text fontSize={"base"}>{moment(reservation?.startDateTime).format("dddd DD MMMM")}</Text>
    <Flex
      color={"white"}
      background={"primary"}
      borderRadius="8px"
      height={"40px"}
      width="100px"
      fontSize={"18px"}
      alignItems="center"
      justifyContent={"center"}
    >
      {moment(reservation?.startDateTime).format("HH:mm")}
    </Flex>
   </Flex>
  )
}

export default ReservationDetailsDate